import { css } from "@emotion/core";

import { color, fontSizes, fonts } from "../../../theme/Theme";

export const myInfoCardStyles = css({
  ".profile-text": {
    color: color.darkGrey
  },
  ".ant-progress-inner": {
    background: color.progressTrail
  },
  ".ant-progress-text": {
    fontSize: fontSizes.label,
    fontFamily: fonts.bold
  },
  ".active-percent-format": {
    color: color.darkGrey
  }
});
